<template>
  <Dialog
    :visible="visibleLocal"
    modal
    header="Edit Profile"
    :style="{ width: '25rem' }"
    @update:visible="emitVisible"
    fullscreen
  >
    <H5PWrapper :h5p-id="storeCourse.getData.h5pId" />
  </Dialog>
</template>

<script setup>
import { useCourseStudentStore } from "@/store/course-student";
import { defineProps, defineEmits, ref, watch } from "vue";

const storeCourse = useCourseStudentStore;

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const visibleLocal = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    visibleLocal.value = val;
  }
);

function emitVisible(val) {
  emit("update:modelValue", val);
}
</script>
